import { ApiError, type NovaSsoTicket } from './api'
import { safeReturnPath } from './auth'
import { NOVA_AI_SSO_URL } from '@/config/external-links'

const configuredLaunchUrl = import.meta.env.VITE_NOVA_AI_LAUNCH_URL || NOVA_AI_SSO_URL

export function buildNovaAiLaunchUrl(ticket: NovaSsoTicket, next: unknown): string {
  let configured: URL
  let launch: URL
  try {
    configured = new URL(configuredLaunchUrl)
    launch = new URL(ticket.launchUrl)
  } catch {
    throw new ApiError('AI 登录地址配置无效', 'INVALID_RESPONSE')
  }

  if (configured.protocol !== 'https:' || configured.username || configured.password
    || configured.search || configured.hash || configured.pathname !== '/auth/yudao') {
    throw new ApiError('AI 登录地址配置无效', 'INVALID_RESPONSE')
  }
  if (launch.origin !== configured.origin || launch.pathname !== configured.pathname
    || launch.username || launch.password || launch.search) {
    throw new ApiError('AI 登录地址未通过安全校验', 'INVALID_RESPONSE')
  }

  const fragment = new URLSearchParams(launch.hash.replace(/^#/, ''))
  if (!ticket.ticket || !ticket.audience
    || fragment.get('ticket') !== ticket.ticket
    || fragment.get('audience') !== ticket.audience) {
    throw new ApiError('AI 登录票据不完整', 'INVALID_RESPONSE')
  }

  launch.searchParams.set('next', safeReturnPath(next, '/create'))
  return launch.toString()
}
